import { Tooltip, TooltipProps } from '@mui/material';
import { ReactElement, useState } from 'react';

const popperModifiers = [
    {
        name: 'offset' as const,
        options: { offset: [-9, -2] },
    },
];

const tooltipSx = (theme: {
    palette: { divider: string; background: { paper: string } };
}) => ({
    py: 2,
    px: 2,
    borderRadius: 0,
    border: `1px solid ${theme.palette.divider}`,
    backgroundColor: theme.palette.background.paper,
});

interface PropertiesTooltipProps
    extends Omit<TooltipProps, 'placement' | 'enterDelay' | 'leaveDelay'> {
    children: ReactElement;
}

export default function PropertiesTooltip({
    children,
    ...rest
}: PropertiesTooltipProps) {
    const [open, setOpen] = useState(false);

    return (
        <Tooltip
            open={open}
            onOpen={() => setOpen(true)}
            onClose={() => setOpen(false)}
            placement="right-start"
            enterDelay={500}
            leaveDelay={200}
            slotProps={{
                popper: { modifiers: popperModifiers },
                tooltip: {
                    sx: tooltipSx,
                    onClickCapture: () => setOpen(false),
                },
            }}
            {...rest}
        >
            {children}
        </Tooltip>
    );
}
